import React from 'react';
import { useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../../pages/lomavisCreator';

const IGGridPreview = ({ platform }) => {
  const editedPreviewImage = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform].editedImageThumbnail.url
  );
  return (
    <div className="w-100 h-100 d-flex align-items-center justify-content-center">
      <div
        style={{ width: '90%', maxHeight: '80%', overflowY: 'hidden' }}
        className="border border-top-0 border-bottom-3 rounded-3 mx-auto d-flex flex-column gap-3 p-2"
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '1px',
            overflowY: 'auto'
          }}
          className="flex-fill"
        >
          {new Array(9).fill(null)?.map((item, index) => (
            <div
              style={{
                width: '33%',
                minWidth: '60px',
                aspectRatio: 0.8,
                paddingBottom: '2px'
              }}
              className="position-relative bg-secondary flex-fill"
            >
              {index === 4 && (
                <img
                  style={{ objectFit: 'cover' }}
                  src={editedPreviewImage}
                  alt="Image preview"
                  className="d-flex w-100 h-100"
                ></img>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IGGridPreview;
